// @ts-ignore
import packageInfo from '../../package.json';
export const environment = {
  production: true,
  apiUrl: 'https://api-vendor.aclarian.com/api/',
  baseUrl: 'https://cityofdestin.aclarian.com',
  appName: 'City of Destin | VendorV2',
  tokenizationKey: 'PaQmTu-VE6uUF-9V6acY-jecjXr',
  datadogClientToken: 'pub00f549c90a98384ccee0739261d159a2',
  datadogApplicationId: 'fe423de7-57f1-41c0-9184-7f7cfc7466f3',
  datadogService: 'invoicing_cityofdestin_prod',
  ApiKey: 'Tq7@XMG%vL95Fp#O',
  env: 'PROD',
  version: packageInfo.version,
};
